export const formatList = (value, separator = " · ") => {
  const filtered = Array.isArray(value) ? value.filter(Boolean) : [];
  return filtered.length ? filtered.join(separator) : "-";
};
